import type { AdminPage } from '../adminPages'
import { Card, CardDescription, CardLabel } from './AdminHome.styled'

type AdminHomeCardProps = {
  page: AdminPage
}

/** One admin tool on the admin home: its name and what it is for, linking to it. */
export const AdminHomeCard = ({ page }: AdminHomeCardProps) => (
  <Card to={page.path} data-testid="admin-home-card">
    <CardLabel>{page.label}</CardLabel>
    <CardDescription>{page.description}</CardDescription>
  </Card>
)
